import { useEffect, useRef } from 'react';
import { io, type Socket } from 'socket.io-client';
import {
  CLIENT_SUPPORT_CHAT_EVENTS,
  CLIENT_SUPPORT_CHAT_WS_NAMESPACE,
  CLIENT_SUPPORT_CHAT_WS_PATH,
  type ClientSupportChatMessageEvent,
} from '../types';

function getAccessToken(): string | null {
  return localStorage.getItem('access_token');
}

type Handlers = {
  onMessage?: (payload: ClientSupportChatMessageEvent) => void;
  onUnread?: (payload: {
    scope: 'client' | 'admin';
    count: number;
    userId?: number;
  }) => void;
};

export function useClientSupportChatSocket(handlers: Handlers, enabled = true) {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    if (!enabled) return undefined;

    const token = getAccessToken();
    if (!token) return undefined;

    const socket: Socket = io(CLIENT_SUPPORT_CHAT_WS_NAMESPACE, {
      path: CLIENT_SUPPORT_CHAT_WS_PATH,
      transports: ['websocket', 'polling'],
      auth: { token },
    });

    socket.on(CLIENT_SUPPORT_CHAT_EVENTS.messageNew, (payload) => {
      handlersRef.current.onMessage?.(payload);
    });
    socket.on(CLIENT_SUPPORT_CHAT_EVENTS.unread, (payload) => {
      handlersRef.current.onUnread?.(payload);
    });

    return () => {
      socket.disconnect();
    };
  }, [enabled]);
}
